import { styled } from '@uhg-abyss/web/tools/styled';
import { Flex } from '@uhg-abyss/web/ui/Flex';

export const CollapseCardHeaderStyle = {
  backgroundColor: 'white',
  borderRadius: 'unset',
  border: 'none',
  borderLeft: 'none',
  borderRight: 'none',
  boxShadow: 'none',
  color: '$core.color.brand.100',
  fontSize: '20.25px',
  fontWeight: 'bold',
  lineHeight: '24px',
  marginBottom: '16px',
  minHeight: 'unset',
  padding: '0',
  '.abyss-card-title': {
    margin: '$md 0',
    maxHeight: '24px',
  },
};

export const SpecialityCollapseProvider = styled('div', {
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'center',
});
export const SpecialityCollapseHeaderProvider = styled('button', {
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-end',
  padding: '12px $md',
  borderTop: '1px solid $core.color.neutral.30',
  textAlign: 'left',
});
export const CollapseName = styled('div', {
  fontSize: '$lg',
  color: '$core.color.neutral.90',
});
export const CollapseIconContainer = styled('div', {});

export const SectionContainer = styled(Flex, {
  alignItems: 'start',
  padding: '$md',
  '@media (max-width: 1248px)': {
    padding: '$md $lg',
  },
  '@media (max-width: 744px)': {
    padding: '$md',
  },
});

export const NoProviderText = styled('p', {
  color: '$core.color.neutral.90',
  marginBottom: '$md',
});
